import { render, staticRenderFns } from "./UnitManage.vue?vue&type=template&id=f204f23a"
import script from "./UnitManage.vue?vue&type=script&lang=js"
export * from "./UnitManage.vue?vue&type=script&lang=js"
import style0 from "./UnitManage.vue?vue&type=style&index=0&id=f204f23a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports